import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CreateApi, CreateApiImpl } from '@/infrastructure/api-functions/create-api';
import { CreateService, CreateServiceImpl } from '@/services/create-service';

export const createModule = new ContainerModule((bind) => {
    bind(CreateApi).to(CreateApiImpl);
    bind(CreateService).to(CreateServiceImpl);
});
